import React, { useEffect, useState } from 'react';
import { ClockIcon, FlameIcon } from 'lucide-react';
export function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState(14 * 60 + 50); // 14:50 in seconds
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev <= 0) {
          return 14 * 60 + 50; // Reset to 14:50
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  return <div className="fixed top-0 left-0 right-0 z-50 bg-gradient-to-r from-red-600 to-red-700 text-white py-1.5 px-4 shadow-lg" data-id="element-1">
      <div className="max-w-7xl mx-auto flex items-center justify-center gap-3 md:gap-6 text-xs md:text-sm font-bold flex-wrap" data-id="element-2">
        <div className="flex items-center gap-2" data-id="element-3">
          <ClockIcon className="w-4 h-4 animate-pulse" aria-hidden="true" data-id="element-4" />
          <span data-id="element-5">OFERTA EXPIRA EN:</span>
          <span className="text-yellow-300 text-sm md:text-base font-mono" data-id="element-6">
            {String(minutes).padStart(2, '0')}:
            {String(seconds).padStart(2, '0')}
          </span>
        </div>
        <div className="flex items-center gap-2" data-id="element-7">
          <span className="text-yellow-300" data-id="element-8">|</span>
          <FlameIcon className="w-4 h-4 text-yellow-300 animate-pulse" aria-hidden="true" data-id="element-9" />
          <span data-id="element-10">CUPOS LIMITADOS</span>
        </div>
      </div>
    </div>;
}